"use strict";

/**
 * Предоставляет инструменты для работы с буфером обмена через Веб-агент. Например, скопировать ссылки в буфер обмена.
 *
 * @namespace WebAccess.agent.clipboard
 * @since 5.1.0.1500
 */
(function (global) {
  var clipboard = {

      /**
       * Скопировать массив ссылок в буфер обмена.
       *
       * @method WebAccess.agent.clipboard#copyLinksToClipboard
       * @param  {array} links Массив ссылок для перемещения в буфер обмена
       * @return {Deferred<Number>} Количество скопированных ссылок.
       * @see https://api.jquery.com/category/deferred-object/
       */
      copyLinksToClipboard: function (links) {
        var d = $.Deferred();
        var transmittedRefs = 0;

        var addLink = function (link) {
          var g = $.Deferred();
          global.transmitRequest("AddLinkToClipboard", "Clipboard", link).done(function (res) {
            if (res.success) {
              transmittedRefs++;
            }
            g.resolve();
          });
          return g.promise();
        };

        //первая ссылка копируется в буфер
        global.transmitRequest("CopyLinkToClipboard", "Clipboard", links[0]).always(function (res) {
          if (res.success) transmittedRefs++;
          //все последующие ссылки добавляются к первой
          var deferreds = [];
          for (var i = 1; i < links.length; i++)
            deferreds.push(addLink(links[i]));
          //когда все ссылки добавятся, возвращаем число успешно скопированных
          $.when.apply(null, deferreds).then(function () {
            d.resolve(transmittedRefs);
          });
        });

        return d.promise();
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
       * Получить объект-папку, из которой были скопированы ссылки. Необходим для вырезания ссылок.
       *
       * @method WebAccess.agent.clipboard#getLinkSourceLocation
       * @return {Deferred<Object>} Объект-папка, из которой были скопированы ссылки.
       * @see https://api.jquery.com/category/deferred-object/
       */
      getLinkSourceLocation: function () {
        var d = $.Deferred();
        global.transmitRequest("GetLinksSource", "Clipboard", {}).done(function (response) {
          d.resolve(response.result);
        });
        return d.promise();
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
       * Получает массив объектов ссылок из буфера обмена.
       *
       * @method WebAccess.agent.clipboard#getLinksFromClipboard
       * @return {Deferred<Array<WA.Link>>} Массив объектов ссылок.
       * @see https://api.jquery.com/category/deferred-object/
       */
      getLinksFromClipboard: function () {
        var d = $.Deferred();
        global.transmitRequest("PasteLinksFromClipboard", "Clipboard", {}).always(function (response) {
          if (response.success) {
            var links = response.result;
            if (links.length > 0) {
              //Преобразовываем ссылки к нужному формату, FIXME: привести потом всё к одному виду
              for (var i = 0; i < links.length; i++) {
                links[i].Kind = (links[i].Kind == 'E' ? 'EDOC' : links[i].Kind);
                links[i].Kind = (links[i].Kind == 'F' ? 'FOL' : links[i].Kind);
                links[i].Kind = (links[i].Kind == 'T' ? 'TASK' : links[i].Kind);
                links[i].Kind = (links[i].Kind == 'J' ? 'JOB' : links[i].Kind);
                links[i].Kind = (links[i].Kind == 'R' ? 'REF' : links[i].Kind);
              }
            }
            d.resolve(links);
          } else {
            d.reject();
          }
        });

        return d.promise();
      }
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.clipboard = clipboard;

})(window.WebAccess.agent);
